export const PUBLIC = "public";
export const LOCAL = "local";
export const FAVORITE = "favorite";
